// extracted by mini-css-extract-plugin
export default {"favoriteContainer":"favoriteButton_favoriteContainer__WRPoN","customIconClass":"favoriteButton_customIconClass__NP3fx","favoriteButton":"favoriteButton_favoriteButton__2vh6H"};